import React, { Suspense } from "react";
import type { FC } from "react";

import { BugReportModalWithNoAv } from "./BugReportModalWithNoAv";

import { ClassSessionCategory } from "components/server-types";
import { useAppSelector } from "store/index";
import { selectActiveClassSession } from "store/selectors";

const BugReportModalWithAv = React.lazy(() =>
  import("./BugReportModalWithAv").then((mod) => ({ default: mod.BugReportModalWithAv })),
);

type BugReportModalProps = {
  open: boolean;
  onClose: () => void;
};

export const BugReportModal: FC<BugReportModalProps> = ({ open, onClose }) => {
  const classSession = useAppSelector(selectActiveClassSession);
  if (classSession?.category === ClassSessionCategory.VIRTUAL) {
    return (
      <Suspense fallback={null}>
        <BugReportModalWithAv open={open} onClose={onClose} />
      </Suspense>
    );
  }
  return <BugReportModalWithNoAv open={open} onClose={onClose} />;
};
